import ListUser from '../auth.User.List.i18n';
import ListAdmin from '../auth.Admin.List.i18n';
import ListPartner from '../auth.Partner.List.i18n';

export default {
  name : "authList",
  props: ['user', 'auto_refresh'],
  components: { ListUser, ListAdmin, ListPartner, },
  data: () => ({
  }),
  computed: {
  },
  methods: {
  },
  created() { console.log('log.auth.vue', 'created'); },
  destroyed() { console.log('log.auth.vue', 'destroyed'); },
  mounted() {
    console.log('log.auth.vue', 'mounted');
    if(this.auto_refresh == true) { this.sync.enable = this.auto_refresh; }
    if(this.user) {
      this.so.sk = 'addr'
      this.so.skt = 'Address'
    }
  },
}